import React from "react"
import { Grid, makeStyles, Typography } from "@material-ui/core"
import { Link } from "gatsby"

import { responsiveFontSize } from "../Theme"
import { INSTAGRAM_URL } from "../../constants"

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
    // MUI v4のspacingはnegative marginで横スクロールを生むため、gapで間隔を取る
    gap: "0.8rem 1.6rem",
  },
  link: {
    fontFamily: "ヒラギノ丸ゴ ProN W4",
    color: "blue",
    textDecoration: "underline",
    textAlign: "center",
    ...responsiveFontSize(theme, {
      base: "1.4rem",
      sm: "1.6rem",
      md: "1.8rem",
    }),
  },
}))

const Nav = () => {
  const classes = useStyles()
  return (
    <nav aria-label="サイト内メニュー">
      <Grid container justifyContent="space-evenly" className={classes.root}>
        <Grid item>
          <Typography variant="body1" className={classes.link}>
            <Link to="/">ホーム</Link>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" className={classes.link}>
            <Link to="/menu">MENU/価格表</Link>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" className={classes.link}>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
              ギャラリー
            </a>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" className={classes.link}>
            <Link to="/access">アクセス</Link>
          </Typography>
        </Grid>
      </Grid>
    </nav>
  )
}

export default Nav
